"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Level = /** @class */ (function () {
    function Level(name) {
        this.name = name;
    }
    Level.DEBUG = new Level("[Debug]");
    Level.INFO = new Level("[Information]");
    Level.NOTICE = new Level("[Notice]");
    Level.WARNING = new Level("[Warning]");
    Level.ERROR = new Level("[Error]");
    Level.CRITICAL = new Level("[Critical]");
    Level.ALERT = new Level("[Alert]");
    Level.EMERGENCY = new Level("[Emergency]");
    return Level;
}());
exports.Level = Level;
;
